module.exports = __webpack_public_path__ + "img/apiwise1.70a8832b.png";